import React from 'react';

import ReactEmoji from 'react-emoji';

import './Message.css';

const Message = ( {message :{ user, text }, name} ) =>{
let isSentByCurrentUser = false;

const trimmedName =name.trim().toLowerCase();
const nameCapitalized= trimmedName.charAt(0).toUpperCase() + trimmedName.slice(1);
const UserNameCapitalized= user.charAt(0).toUpperCase() + user.slice(1);
const tempDate = new Date();
const time = tempDate.getHours()+':'+ tempDate.getMinutes();


    if(user === trimmedName)
    {
        isSentByCurrentUser = true;
    }

    return(
        isSentByCurrentUser
        ?
            (
                <div className="messageContainer justifyEnd">
                        <div className="messageBox backgroundBlue">
                        <p className="sentText pr-10">{nameCapitalized}</p>
                            <p className="messageText colorWhite">{ReactEmoji.emojify(text)}</p>
                            <p className="currentTime"> {time}</p> 
                        </div>
                </div>
            )
        :
            (
                <div className="messageContainer justifyStart">
                    <div className="messageBox backgroundLight">
                        <p className="sentText pl-10">{UserNameCapitalized
                        }</p>
                        <p className="messageText colorDark">{ReactEmoji.emojify(text)}</p>
                        <p className="currentTime"> {time}</p>
                    </div>
                   
                </div>
            )
    )
};
    
export default Message;